import { EAnalyticColumnKey, EPageField, EPageMetric } from '~/core/gemxql/types';
import { EMetricKey } from '~/types/metric';

export const PA_SEARCH_FIELDS: EPageField[] = [EPageField.PAGE_TITLE, EPageField.PAGE_PATH];

export const LINE_CHART_METRIC_KEYS: EMetricKey[] = [
  EMetricKey.SESSION,
  EMetricKey.VISITORS,
  EMetricKey.BOUNCE_RATE,
  EMetricKey.CTR,
  EMetricKey.AVG_TIME_ON_PAGE,
  EMetricKey.PAGE_VIEWS,
  EMetricKey.RPV,
  EMetricKey.CART_ADDITION,
  EMetricKey.REACHED_CHECKOUT,
  EMetricKey.COMPLETE_CHECKOUT,
  EMetricKey.CONVERSION_RATE,
  EMetricKey.AOV,
  EMetricKey.REVENUE,
  EMetricKey.ADDED_TO_CART,
  EMetricKey.ADD_TO_CART_RATE,
  EMetricKey.ORDERS,
];

const DONUT_BREAKDOWN_KEYS: string[] = [
  EAnalyticColumnKey.VISITOR_ITEMS,
  EAnalyticColumnKey.DEVICE_ITEMS,
  EAnalyticColumnKey.TRAFFIC_SOURCE_ITEMS,
];

export const DETAIL_METRIC_LIST: string[] = [
  ...LINE_CHART_METRIC_KEYS,
  ...DONUT_BREAKDOWN_KEYS,
  EPageMetric.PAGE_ITEMS,
];
